import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { CrownIcon } from './icons/GoldIcons';
import { GalleryMarquee } from './GalleryMarquee';
export function Founders() {
  const {
    t
  } = useLanguage();
  return <section id="nosotras" className="w-full bg-ink-800 py-24 sm:py-32" data-id="element-91" data-mp="162wa7acatlxp">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-[0.85fr_1fr] lg:gap-20" data-id="element-92" data-mp="115vyojwojqz7">
        <GalleryMarquee data-id="element-93" data-mp="w7kou96dxggz" />

        <div data-id="element-94" data-mp="w7uiq7ujw7ry">
          <p className="text-[11px] font-medium uppercase tracking-[0.32em] text-gold-muted" data-id="element-95" data-mp="rfb1n0wnmuie">
            {t.founders.eyebrow}
          </p>
          <h2 className="gold-shine mt-4 font-display text-3xl font-semibold leading-tight sm:text-4xl lg:text-[2.9rem]" data-id="element-96" data-mp="nehgugeidvtq">
            {t.founders.title}
          </h2>
          <div className="gold-rule mt-7 h-px w-40" aria-hidden="true" data-id="element-97" data-mp="df8nnprgwl8f" />

          <p className="mt-8 leading-relaxed text-neutral-300" data-id="element-98" data-mp="dhcqe4dmre74">{t.founders.intro}</p>

          <blockquote className="mt-8 border-l-2 border-gold-soft/60 pl-6" data-id="element-99" data-mp="8iibvemp4bst">
            <p lang="en" className="font-display text-xl italic leading-snug text-gold-bright sm:text-2xl" data-id="element-100" data-mp="3a5qf5gabctk">
              “{t.founders.quote}”
            </p>
          </blockquote>

          <p className="mt-8 leading-relaxed text-neutral-300" data-id="element-101" data-mp="3pj6xd8myndqq">{t.founders.body}</p>

          <ul className="mt-8 flex flex-wrap gap-2.5" data-id="element-102" data-mp="3ugp54vp8rmx5">
            {t.founders.hairTypes.map(type => <li key={type} className="rounded-full border border-gold-deep/40 px-4 py-2 text-[12px] uppercase tracking-[0.14em] text-neutral-400" data-id="element-103" data-mp="m1os98ykoku0">
                {type}
              </li>)}
          </ul>

          <p className="mt-10 flex items-center gap-3 text-sm text-gold-soft" data-id="element-104" data-mp="c3r38j8w2k0c">
            <CrownIcon className="h-6 w-6" data-id="element-105" data-mp="h2c2oggbgznq" />
            {t.founders.tagline}
          </p>
        </div>
      </div>
    </section>;
}